import { render, staticRenderFns } from "./StockMovementDialog.vue?vue&type=template&id=51a54b43&"
import script from "./StockMovementDialog.vue?vue&type=script&lang=js&"
export * from "./StockMovementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports